/* INTEGY V697 — collection/search ownership and large-stock coexistence guard.
   Small final owner: preserves custom filter/stock state through native pagination,
   retries canonical owners after late section/grid mutations, and makes submitted
   search ownership deterministic without changing underlying catalog membership. */
(function () {
  'use strict';
  var root = document.documentElement;
  var timers = [];
  var mutationTimer = 0;

  function query() { try { return new URLSearchParams(location.search || ''); } catch (e) { return new URLSearchParams(); } }
  function isCollection() { return !!(document.body && document.body.classList.contains('template-collection')); }
  function isSearch() { return /\/search\/?$/.test(location.pathname || ''); }
  function hasCollectionState() {
    var q = query();
    return q.has('integy_filter') || q.has('integy_filters') || q.has('integy_tag_filter') || q.has('integy_stock') || q.has('filter.v.availability');
  }
  function copyIfPresent(source, target, key) {
    if (!source.has(key)) return;
    target.set(key, source.get(key));
  }
  /* V764: repair the malformed grid-view=grid-view URLs left by older pagers.
     Preserve the chosen view, stock mode, sorting and all other query fields. */
  function normalizePagerView(u) {
    var value = u.searchParams.get('grid_list') || '';
    var duplicate = /^(grid-view|list-view)(?:=\1)+$/i.exec(value);
    if (duplicate) u.searchParams.set('grid_list', duplicate[1].toLowerCase());
  }
  function healPaginationLinks() {
    if (!isCollection()) return;
    var current = query();
    if (!hasCollectionState()) return;
    var keep = ['integy_filter','integy_filters','integy_tag_filter','integy_vehicle_filter','integy_stock','filter.v.availability','sort_by','grid_list'];
    document.querySelectorAll('.pagination--container a[href],.pagination a[href],.integy-v426-filter-pagination a[href],.productgrid--pagination a[href],.pagination-wrapper a[href]').forEach(function (anchor) {
      try {
        var u = new URL(anchor.getAttribute('href') || anchor.href, location.origin);
        if (u.origin !== location.origin || u.pathname !== location.pathname) return;
        keep.forEach(function (key) { copyIfPresent(current, u.searchParams, key); });
        normalizePagerView(u);
        anchor.setAttribute('href', u.pathname + (u.search || '') + (u.hash || ''));
      } catch (e) {}
    });
  }
  function stockMode() {
    var q = query();
    var native = q.get('filter.v.availability');
    var custom = String(q.get('integy_stock') || '').toLowerCase();
    if (native === '0' || custom === 'out') return 'out';
    if (native === '1' || custom === 'in') return 'in';
    return 'all';
  }
  function largeStockOwnsCollection() {
    if (!isCollection()) return false;
    var grid = document.querySelector('[data-productgrid-items],.productgrid--items');
    if (grid && grid.getAttribute('data-integy-v651-large-owner') === 'true') return true;
    if (window.IntegyV701AllStockOwnerActive || window.IntegyV701AllStockOwner || window.IntegyV651LargeStockOwnerActive || window.IntegyV681LargeCollectionStockOwner || window.IntegyV696LargeCollectionStockOwner) return true;
    var cfg = window.INTEGY_V651_LARGE_STOCK_CONFIG || {};
    var mode = stockMode();
    // Critical V697 rule: large, non-indexed collection stock pages belong to the
    // live large-stock owner from first paint onward. Do not let the older V501
    // indexed owner clear/rebuild that grid while V696 is fetching live rows.
    return !!cfg.active && !cfg.indexed && Number(cfg.count || 0) > Number(cfg.threshold || 5000) && (mode === 'in' || mode === 'out');
  }
  function reapplyCollectionOwner() {
    if (!isCollection() || !hasCollectionState()) return;
    healPaginationLinks();
    if (largeStockOwnsCollection()) {
      root.classList.add('integy-v697-large-owner-protected');
      return;
    }
    var owner = window.IntegyV501FilterOwner;
    if (owner && typeof owner.apply === 'function') {
      try { owner.apply(); root.classList.add('integy-v697-collection-owner-armed'); } catch (e) {}
    }
  }
  function reapplySearchOwner(force) {
    if (!isSearch()) return;
    var q = String(query().get('q') || '').trim();
    if (q.length < 2) return;
    var owner = window.IntegyV520SearchOwner;
    if (owner && typeof owner.runSearchPage === 'function') {
      try { owner.runSearchPage({ force: !!force }); root.classList.add('integy-v697-search-owner-armed'); } catch (e) {}
    }
  }
  function run(force) {
    reapplyCollectionOwner();
    reapplySearchOwner(force);
  }
  function schedule() {
    timers.forEach(function (t) { clearTimeout(t); });
    timers = [0, 280, 750, 1500].map(function (delay, index) {
      return setTimeout(function () { run(false); }, delay);
    });
  }
  function onMutation() {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(function () {
      healPaginationLinks();
      if (isCollection() && hasCollectionState()) {
        if (largeStockOwnsCollection()) {
          root.classList.add('integy-v697-large-owner-protected');
          return;
        }
        var grid = document.querySelector('[data-productgrid-items],.productgrid--items');
        if (grid && grid.getAttribute('data-integy-v634-render-settled') !== 'true') reapplyCollectionOwner();
      }
    }, 140);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  window.addEventListener('pageshow', function (e) { schedule(); if (e && e.persisted) setTimeout(function(){ run(true); }, 50); });
  window.addEventListener('popstate', function () { setTimeout(function(){ run(true); }, 0); });
  document.addEventListener('shopify:section:load', function () { schedule(); run(true); });
  document.addEventListener('integy:v429:filter-rendered', healPaginationLinks);
  document.addEventListener('integy:v696:large-stock-ready', healPaginationLinks);
  document.addEventListener('integy:v520-search-ready', function () { reapplySearchOwner(false); });
  if (window.MutationObserver) {
    new MutationObserver(onMutation).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
